var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptydataImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "129px",
    height: "113px",
    viewBox: "0 0 129 113",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1_\\u6211\\u7684\\u5E94\\u7528_\\u65E0\\u5E94\\u7528",
    transform: "translate(-981.000000, -351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(981.000000, 351.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#E7EFFF",
    cx: 64,
    cy: 94.5069721,
    rx: 64,
    ry: 18
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-19",
    fill: "#E7EFFF",
    points: "62.0097656 31.2374409 106.136719 41.6729878 75.0664062 57.5069721 31.1230469 46.8878315"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-18",
    fill: "#0058DB",
    points: "106.136719 41.6729878 106.136719 81.301894 75.7949219 106.085097 75.7949219 57.5069721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7949219,57.5069721 C75.7949219,89.8923888 75.7949219,106.085097 75.7949219,106.085097 C75.7949219,106.085097 60.9042969,101.296686 31.1230469,91.7198628 L31.1230469,46.8878315 L75.7949219,57.5069721 Z",
    id: "\\u8DEF\\u5F84-24",
    fill: "#3F8CFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-25",
    fill: "#DEE5F4",
    points: "75.7949219 57.5069721 64.8808594 83.6495503 20.2714844 70.5782612 31.1230469 46.8878315"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-26",
    fill: "#E0E6F0",
    points: "106.136719 41.6729878 116.576172 65.2686909 106.136719 65.2686909"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-27",
    fill: "#0058DB",
    points: "62.0097656 31.2374409 62.0097656 54.6786829 31.1230469 46.8878315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7363281,25.6261128 C92.9016927,24.2732482 98.9264323,21.9002013 101.810547,18.5069721 C106.136719,13.4171284 94.5810547,11.3878315 92.7734375,18.5069721 C90.9658203,25.6261128 105.152344,29.7823628 116.576172,13.8311909",
    id: "\\u8DEF\\u5F84-28",
    stroke: "#E0E6F0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.187793,8.20586677 C120.708029,2.22093959 123.395802,0.41366118 126.251111,2.78403155 C129.10642,5.15440192 126.418647,6.96168033 118.187793,8.20586677 Z",
    id: "\\u8DEF\\u5F84-29",
    fill: "#E0E6F0",
    transform: "translate(122.771004, 4.990599) rotate(-28.000000) translate(-122.771004, -4.990599) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptydataImg);
export default __webpack_public_path__ + "static/media/Emptydata_img.1a34a8691920d5faab2130d4e02e9854.svg";
export { ForwardRef as ReactComponent };